<template>
    <div class="animated fadeIn bgV2 safetyApp">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="suppliers"
                        arrows >
                    <template slot="gofixTab:suppliers">
                        <gofix-card fullContent class="mb-0">
                            <gofix-table :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @row-click="clickToRowItem"
                                @new-item="newItem"
                                @delete-items="deleteItems"
                                ref="gofixTable">
                                <template slot="gofix_table:modal-remove-desc">
                                    <br/>Once deleted, all users from the previous supplier will be removed from the <strong>Supplier Staff</strong> tab.
                                </template>
                            </gofix-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            :title="`${modals.add.data.id ? 'Edit' : 'Add'} Supplier`" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown 
                            label="Company" 
                            vLabel="name"
                            required
                            show-icon-required
                            :filterable="false"
                            @search="searchCompanies"
                            v-model="modals.add.data.company" 
                            :options="modals.add.options.companies">
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="checkValidate" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.confirm.open">
            <div class="py-4 px-1">
                Are you sure you want to change the <strong>supplier</strong>? <br>
                Once changed, all users from the previous supplier will be removed from the <strong>Supplier Staff</strong> tab.
            </div>
            <b-button-group class="btn-group">
            <b-button class="custom-btn" @click="modals.confirm.open = false">Cancel</b-button>
            <b-button class="custom-btn" @click="save" :disabled="modals.confirm.loading">
                <b-spinner v-if="modals.confirm.loading" small type="grow"></b-spinner>Confirm
            </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>

<script>
import { filters } from '@/_filterVar.js'
import tabData from '@/data/_tabs';
import { mapGetters } from 'vuex';

export default {
    name: 'safety-suppliers-list',
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_suppliers_listing']));
        return {
            contract_tab:tabData.safety_projects,
            tableConfig:{
                name: 'safety-suppliers-listing',
                controls:{
                    create: true,
                    delete: true,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "desc",
                fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'company_id',
                            label: 'Company ID',
                            thStyle: "width:200px",
                            width: 200,
                            isActive: 1,
                            isFilter: true,
                            sorting: true
                        },
                        {
                            key: 'company_name',
                            label: 'Company Name',
                            isActive: 1,
                            isFilter: true,
                            thStyle: "width:300px",
                            width: 150,
                            sorting: true
                        }
                    ]
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        project_id: null,
                        company: null,
                        company_id_current: null
                    },
                    options: {
                        companies: []
                    }
                },
                confirm: {
                    open: false,
                    loading: false
                },
            },
            timer: {
                save: null,
                companies: null
            },
        }
    },
    computed: {
        ...mapGetters({
            contract: 'ContractController/SContract',
        }),
    },
    watch: {
        contract: function() {
            this.getCompanies()
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.project_id.value = this.$route.params.id
                await this.$store.dispatch("SafetyAppController/getSafetySupplierItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of safety suppliers", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        }, 
        async getCompanies(search = '') {
            if(!this.contract || !this.contract.client_contract) return;
            let tableRequest = {
                isCMS: 1,
                filter: { 
                    name: { type: "text", value: search, function: "ilike", with: [] },
                    is_supplier: { type: 'boolean', value: true },
                    is_safety: { type: 'boolean', value: true },
                }, 
                page: 1,
                limit: 100
            }

            await this.$store.dispatch("OrganizationController/getItemsNoCommit", tableRequest)
                .then(response => {
                    this.modals.add.options.companies = response.data.data.items;
                })
                .catch(err => {})
        },
        async searchCompanies(search, loading) {
            loading(true)
            this.modals.add.options.companies = []
            if (this.timer.companies) {
                clearTimeout(this.timer.companies);
                this.timer.companies = null;
            }
            this.timer.companies = setTimeout(async () => {
                try {
                    await this.getCompanies(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        clickToRowItem(item) {
           this.modals.add.data = {
                id: item.id,
                project_id: item.project_id,
                company: {
                    id: item.company_id,
                    name: item.company_name
                },
                company_id_current: item.company_id
            };

            this.modals.add.open = true;
        },
        newItem() {
            this.modals.add.data = {
                id: null,
                project_id: Number(this.$route.params.id),
                company: null,
                company_id_current: null
            };
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteSafetySupplierItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safety_suppliers'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                if(this.modals.confirm.open) {
                    this.modals.confirm.loading = true
                }

                let objeClone = {
                    id: this.modals.add.data.id,
                    data: {
                        project_id: this.modals.add.data.project_id,
                        company_id: this.modals.add.data.company.id,
                        company_name: this.modals.add.data.company.name,
                    }
                };
                
                this.$store.dispatch("SafetyAppController/saveSafetySupplierItem", objeClone)
                .then(async response => {
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    this.modals.confirm.open = false;
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(this.$notificationV2('adding', 'safety_suppliers'), "success");
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                }).finally(() => {
                    this.modals.add.loading = false;
                    this.modals.confirm.loading = false;
                });

            }, 200);
        },
        checkValidate() {
            if(!this.modals.add.data.company) {
                return this.$alertNotification("Company is required.", "danger");
            }

            if(this.modals.add.data.id && this.modals.add.data.company && this.modals.add.data.company.id != this.modals.add.data.company_id_current) {
                this.modals.confirm.open = true
                return
            }

            if(this.modals.add.loading) return;
            this.modals.add.loading = true;
            this.save();
        }
    },
    created() {
        if(!this.$route.params.hasOwnProperty('id') || isNaN(this.$route.params.id)) {
            return this.$router.push(`/v2/contract-supplier`);
        }
        if((!this.contract || !this.contract.id) || this.contract.hasOwnProperty('id')) {
            this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
                .catch(error => { this.$router.push(`/v2/contract-supplier`) })
        }
        this.getCompanies()
    }
}
</script>